const locations = [
    {
        i: 1,
        name: "Dashboard",
        link: "/",
    },
    {
        i: 2,
        name: "Holidays",
        link: "/holidays",
    },
    {
        i: 4,
        name: "Add Holiday",
        link: "/holidays/addholiday",
    },
    {
        i: 5,
        name: "Documents",
        link: "/documents",
    },
    {
        i: 6,
        name: "Skills review",
        link: "/skills",
    },
    {
        i: 7,
        name: "My Skills",
        link: "/skills/edit",
    },
    {
        i: 8,
        name: "List",
        link: "/skills/list",
    },
    {
        i: 9,
        name: "Register",
        link: "/register",
    },
    {
        i: 11,
        name: "Users",
        link: "/users",
    },
    {
        i: 12,
        name: "Clients",
        link: "/clients",
    },
    {
        i: 14,
        name: "Projects",
        link: "/projects",
    },
    {
        i: 19,
        name: "Handle Holidays",
        link: "/holidays/manageholiday",
    },
    {
        i: 20,
        name: "National Holidays",
        link: "/holidays/nationalholidays",
    },
    {
        i: 21,
        name: "Organizations",
        link: "/organizations",
    },
    {
        i: 15,
        name: "Logout",
        link: "/#",
    },
];

export default locations;
